import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import * as HubActions from 'src/app/root-store/hub-connection-store/hub-connection.actions';
import { HubConnectionService } from 'src/app/shared/services/realtime-connection.service';
import { ReverseInvoiceHubMessage } from 'src/app/shared/services/realtime-constants';
import {
    disconnectFromReverseInvoiceProcessingFeed,
    ensureConnectedToReverseInvoiceProcessingFeed,
    processReverseInvoiceFailure,
    processReverseInvoiceSuccess
} from '../actions/reverse-invoice.actions';

interface ProcessInvoiceFailure {
    error: string;
}

@Injectable()
export class ReverseInvoiceEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _hubConnectionService: HubConnectionService
    ) {}

    reverseInvoiceProcessSuccess$ = createEffect(() => {
        return this._hubConnectionService.reverseInvoiceHub
            .messagesOf<[]>(ReverseInvoiceHubMessage.REVERSE_INVOICE_PROCESS_SUCCESS)
            .pipe(map((created) => processReverseInvoiceSuccess({ created })));
    });

    reverseInvoiceProcessFailure$ = createEffect(() => {
        return this._hubConnectionService.reverseInvoiceHub
            .messagesOf<ProcessInvoiceFailure>(ReverseInvoiceHubMessage.REVERSE_INVOICE_PROCESS_FAILURE)
            .pipe(map((error) => processReverseInvoiceFailure(error)));
    });

    connectToSignalR$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(ensureConnectedToReverseInvoiceProcessingFeed),
            map(() => HubActions.connectToReverseInvoiceHub())
        );
    });

    disconnectFromSignalR$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(disconnectFromReverseInvoiceProcessingFeed),
            map(() => HubActions.disconnectFromReverseInvoiceHub())
        );
    });
}
